import React, { createContext, useContext, useState } from "react";

const PlayerContext = createContext(null);

export function PlayerProvider({ children }) {
  const [queue, setQueue] = useState([]);
  const [index, setIndex] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);

  const current = queue[index] || null;

  const playTrack = (track, list) => {
    const q = list && list.length ? list : [track];
    const i = Math.max(0, q.findIndex((t) => t.id === track.id));
    setQueue(q);
    setIndex(i);
    setIsPlaying(true);
  };

  const togglePlay = () => setIsPlaying((p) => !p);
  const next = () => { if (index < queue.length - 1) { setIndex(index + 1); setIsPlaying(true); } };
  const prev = () => { if (index > 0) { setIndex(index - 1); setIsPlaying(true); } };

  return (
    <PlayerContext.Provider value={{ queue, current, index, isPlaying, setIsPlaying, playTrack, togglePlay, next, prev }}>
      {children}
    </PlayerContext.Provider>
  );
}

export const usePlayer = () => useContext(PlayerContext);
